import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// iOS-style middle truncation: keeps the start and end of a string (so
// extensions and distinguishing suffixes stay visible) instead of cutting
// off the end. Container width can't reliably bound long unbroken strings
// with CSS truncate alone, so we shorten the string itself.
export function truncateMiddle(value: string, maxLength = 32): string {
  if (value.length <= maxLength) return value;
  const keep = maxLength - 1; // reserve 1 char for the ellipsis
  const head = Math.ceil(keep * 0.6);
  const tail = keep - head;
  return `${value.slice(0, head)}…${value.slice(value.length - tail)}`;
}
